/**
 * Описания статусов заказа и доставки Достависты для отображения в админке.
 * Соответствуют бэкенду: be/src/delivery/dostavista-status.enum.ts
 */

export const DOSTAVISTA_ORDER_STATUS_LABELS: Record<string, string> = {
  new: 'Заказ создан и проходит проверку в системе',
  available: 'Заказ прошел проверку и доступен курьерам',
  active: 'Заказ выполняется курьером',
  completed: 'Заказ выполнен',
  reactivated: 'Заказ находится на редактировании у оператора',
  draft: 'Черновик заказа',
  canceled: 'Заказ отменен',
  delayed: 'Заказ отложен',
};

export const DOSTAVISTA_DELIVERY_STATUS_LABELS: Record<string, string> = {
  draft: 'Черновик доставки',
  planned: 'Поиск курьера',
  active: 'Курьер в пути',
  finished: 'Завершена',
  canceled: 'Отменена',
  delayed: 'Отложена',
  courier_assigned: 'Курьер назначен',
  courier_departed: 'Курьер выехал в пвз',
  courier_at_pickup: 'Курьер приехал в пвз',
  parcel_picked_up: 'Курьер забрал заказ',
  courier_arrived: 'Курьер ожидает клиента',
  deleted: 'Доставка удалена',
  return_courier_picked_up: 'Курьер везёт возврат',
  return_finished: 'Возврат товара завершен',
};

export function getOrderStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  return DOSTAVISTA_ORDER_STATUS_LABELS[status] ?? status;
}

export function getDeliveryStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  return DOSTAVISTA_DELIVERY_STATUS_LABELS[status] ?? status;
}
